<template>
  <div class="border px-5 py-3">
    <b-row>
      <b-col cols="12" class="text-center pb-2">
        <h5>{{ details.title }}</h5>
        <small>{{ details.parent  }}</small>
      </b-col>
      <b-col cols="7">
        <b-row v-for="(star, index) in details.stars" v-bind:key="index">
          <b-col cols="2" class="text-center my-auto">
            {{ star['label'] }}
          </b-col>
          <b-col>
            <b-progress :value="star['value']" :max="details.max" show-value class="mb-3 my-auto">
            </b-progress>
          </b-col>
        </b-row>
      </b-col>
      <!-- Resume -->
      <b-col>
        <div class="text-center">
          <h5 style="font-size: 4vw;">{{ number_format(details.average,1) }}</h5>
          <md-icon
            v-for="(star, index) in details.stars"
            v-bind:key="index"
            icon="star"
            :class="getStarColor(details.stars_round, index)"
            style="font-size: 16px; padding-bottom: 4px;"/>

          <div class="text-muted">
            <small>{{ number_format(details.reviews,0,'.',',') }} reseñas</small>
          </div>
        </div>
      </b-col>
      <!-- End Resume -->
    </b-row>

    <!-- Tags classifications -->
    <b-row>
      <b-col>
        <hr>
        <div class="text-center">
          <b-button variant="light" class="mr-1 mt-1" v-for="tag in details.tags" :key="tag.label">
            {{ tag.label }} <b-badge variant="secondary">{{ tag.value }}</b-badge>
          </b-button>
        </div>
      </b-col>
    </b-row>
    <!-- End Tags classifications -->

    <!-- Comments -->
    <b-row>
      <b-col cols="12" class="my-3" v-for="review in details.comments" :key="review.client_name">
        <div class="d-flex justify-content-between">
          <strong>{{ review.client_name }}</strong>
          <div class="text-muted">
            <small>#{{ review.service_number }}</small>
          </div>
        </div>

        <div class="d-flex justify-content-between">
          <div><small class="text-muted">{{ review.product }}</small></div>
          <div><small class="text-muted">{{ review.supplier }}</small></div>
        </div>
        <div>
          <md-icon
            v-for="(star, index) in 5"
            v-bind:key="star"
            icon="star"
            :class="getStarColor(review.stars_round, index)"
            style="font-size: 16px;"/>

          <small class="text-muted ml-2">{{ review.review_date }}</small>
        </div>
        <small>{{ review.comment }}</small>
      </b-col>
    </b-row>
    <!-- End Comments -->

  </div>
</template>
<script>
export default {
  props: {
    details: {
      type: Object
    }
  },
  data() {
    return {
      message: "Hello world!",
      detailss: {
        title: "",
        stars: [
          {"label": 5, "value" : 0},
          {"label": 4, "value" : 0},
          {"label": 3, "value" : 0},
          {"label": 2, "value" : 0},
          {"label": 1, "value" : 0}
        ],
        max: 3,
        average: 3.0,
        parent: '',
        tags: [],
        comments: [],
        platform: "Expedia",
        destination: "CUN",
        supplier: "MyFamilyTours",
        reviews: 10,
        stars_round: 4
      }
    }
  },
  methods: {
    number_format (number, decimals, dec_point, thousands_sep) {
        // Strip all characters but numerical ones.
        number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
        var n = !isFinite(+number) ? 0 : +number,
        prec  = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep   = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec   = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s     = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
        
        // Fix for IE parseFloat(0.55).toFixed(0) = 0;
        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
        if (s[0].length > 3) {
          s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }

        if ((s[1] || '').length < prec) {
          s[1] = s[1] || '';
          s[1] += new Array(prec - s[1].length + 1).join('0');
        }

        return s.join(dec);
      },
      getStarColor(stars_round, index) {
        let color = (stars_round >= index + 1) ?'text-warning' : 'text-secondary';
        return 'font-weight-bolder '+color
      }
  },
}
</script>